// PlayerStatementCard — the player's first-person paragraph, adjacent to
// but clearly distinct from ScoutingNarrativeCard (the agent's third-person
// take). "In their own words" subtitle + italic prose carry the
// distinction visually.
//
// Unlike ScoutingNarrativeCard, this card HIDES entirely when empty (per
// the Tier-1 brief) — the narrative card anchors the main-column rhythm;
// this one is additive.

interface Props {
  statement: string | null
}

export default function PlayerStatementCard({ statement }: Props) {
  if (!statement) return null

  return (
    <section className="bg-hoop-surface border border-hoop-border rounded-2xl p-5">
      <div className="flex items-baseline gap-2 mb-3">
        <h2 className="text-[12px] font-bold uppercase tracking-wider text-hoop-accent">
          Player Statement
        </h2>
        <span className="text-[11px] text-hoop-text-3">
          In their own words
        </span>
      </div>
      <p
        className="whitespace-pre-line text-hoop-text italic"
        style={{ fontSize: '13.5px', lineHeight: 1.7 }}
      >
        {statement}
      </p>
    </section>
  )
}
